import { useNetworkMonitor } from "libs/network-monitor/useNetworkMonitor";
import { useCallback, useRef } from "react";
import { PinService } from "services/pin";
import {
  setFieldAttributes,
  setFieldValue,
} from "../context/FormStateContext/actions";
import {
  FormStateActions,
  FormStateState,
} from "../context/FormStateContext/types";
import {
  DataType,
  DATA_OFFLINE_UPDATE_TRIGGER_DATA_TYPES,
} from "../setup/define";

const isEmpty = (value: any) => value === "" || value === undefined;
interface Option {
  dispatch: React.Dispatch<FormStateActions>;
  state: FormStateState;
  inspectionTypeId: string;
}

const useFormHandler = ({ state, dispatch, inspectionTypeId }: Option) => {
  const formValueRef = useRef(state.formValue);
  formValueRef.current = state.formValue;
  const isOnline = useNetworkMonitor((state) => state.isOnline);
  const isOnlineRef = useRef(isOnline);
  isOnlineRef.current = isOnline;

  const saveFieldValue = useCallback(
    async (itemResultId: string, value: any, dataType: DataType) => {
      let prevValue = formValueRef.current?.[itemResultId] ?? null;

      if (isEmpty(value)) value = null;

      if (isEmpty(prevValue)) prevValue = null;

      if (!state.pinId || prevValue === value) return;

      if (
        value === null &&
        DATA_OFFLINE_UPDATE_TRIGGER_DATA_TYPES.includes(dataType)
      ) {
        dispatch(setFieldValue({ itemResultId, value }));

        return true;
      } else {
        dispatch(setFieldAttributes({ itemResultId, isLoading: true }));
        const result = await PinService.updatePinContent({
          itemResultId,
          value: { data: value ?? "" },
          pinId: state.pinId,
          inspectionTypeId,
          dataType,
        });
        dispatch(setFieldAttributes({ itemResultId, isLoading: false }));
        if (result?.data) {
          dispatch(setFieldValue({ itemResultId, value }));

          return true;
        }
      }

      return false;
    },
    [dispatch, inspectionTypeId, state.pinId]
  );

  return {
    saveFieldValue,
  };
};

export default useFormHandler;
